var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4 9.50045C11.4 10.5903 10.5498 11.4728 9.5 11.4728C8.45025 11.4728 7.6 10.5903 7.6 9.50045C7.6 8.41065 8.45025 7.52809 9.5 7.52809C10.5498 7.52809 11.4 8.41065 11.4 9.50045ZM9.5 13.2276C6.66045 13.2276 3.98525 11.825 2.27905 9.50045C3.98525 7.17587 6.66045 5.77235 9.5 5.77235C12.3396 5.77235 15.0147 7.17587 16.7209 9.50045C15.0147 11.825 12.3396 13.2276 9.5 13.2276ZM9.5 3.79999C5.4378 3.79999 1.89905 6.09594 0 9.50045C1.89905 12.905 5.4378 15.2 9.5 15.2C13.5622 15.2 17.101 12.905 19 9.50045C17.101 6.09594 13.5622 3.79999 9.5 3.79999Z",
    fill: "#8161EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.94878b3c180863d603385df4b7e42b0d.svg";
export { ForwardRef as ReactComponent };